module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-box",
    attrs: {
      "id": "emails-component"
    }
  }, [_c('h4', {
    staticClass: "header-title m-t-0 m-b-10"
  }, [_vm._v("Emails")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.emails,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('iframe', {
          staticStyle: {
            "width": "100%",
            "min-height": "300px",
            "border": "0"
          },
          attrs: {
            "srcdoc": props.row.message
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Plat.",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('source-app', {
          attrs: {
            "name": "devis-b2b",
            "size": "tiny"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "filters": _vm.filterStatus,
      "filter-method": _vm.filterStatusMethod,
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 'PENDING') ? _c('span', {
          staticClass: "label label-secondary"
        }, [_vm._v("En attente (pending)")]) : _vm._e(), _vm._v(" "), (scope.row.status === 'SENT') ? _c('span', {
          staticClass: "label label-primary"
        }, [_vm._v("Envoyé")]) : _vm._e(), _vm._v(" "), (scope.row.status === 'DELAYED') ? _c('span', {
          staticClass: "label label-secondary"
        }, [_vm._v("En attente (delayed)")]) : _vm._e(), _vm._v(" "), (scope.row.status === 'OPENED') ? _c('span', {
          staticClass: "label label-success"
        }, [_vm._v("Ouvert")]) : _vm._e(), _vm._v(" "), (scope.row.status === 'CLICKED') ? _c('span', {
          staticClass: "label label-success"
        }, [_vm._v("Cliqué")]) : _vm._e(), _vm._v(" "), (scope.row.status === 'BOUNCED') ? _c('span', {
          staticClass: "label label-danger"
        }, [_vm._v("Non délivré (bounced)")]) : _vm._e(), _vm._v(" "), (scope.row.status === 'BLOCKED') ? _c('span', {
          staticClass: "label label-danger"
        }, [_vm._v("Non délivré (blocked)")]) : _vm._e(), _vm._v(" "), (scope.row.status === 'SPAM') ? _c('span', {
          staticClass: "label label-dangers"
        }, [_vm._v("Spam")]) : _vm._e(), _vm._v(" "), (scope.row.status === 'DROPPED') ? _c('span', {
          staticClass: "label label-danger"
        }, [_vm._v("Non délivré (dropped)")]) : _vm._e(), _vm._v(" "), (scope.row.status === 'DELIVERED') ? _c('span', {
          staticClass: "label label-primary"
        }, [_vm._v("Délivré")]) : _vm._e(), _vm._v(" "), _c('small', [_vm._v("(" + _vm._s(_vm._f("moment")(scope.row.updated_at, 'DD/MM/YYYY HH:mm')) + ")")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "created_at",
      "label": "Envoyé le"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(_vm._f("moment")(scope.row.created_at.date, 'DD/MM/YYYY')) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "to",
      "filters": _vm.filterTo,
      "filter-method": _vm.filterToMethod,
      "label": "Destinataire"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "subject",
      "filters": _vm.filterSubject,
      "filter-method": _vm.filterSubjectMethod,
      "label": "Sujet"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Pièces jointes"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.attachments.length !== 0) ? _c('ul', _vm._l((scope.row.attachments), function(path, name) {
          return _c('li', [_c('span', {
            staticClass: "label label-primary"
          }, [_c('i', {
            staticClass: "fa fa-file"
          })]), _vm._v(" " + _vm._s(name) + "\n          ")])
        }), 0) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Actions"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.forwardId = scope.row.source_id
            }
          }
        }, [_vm._v("Transférer")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Transférer un email",
      "visible": _vm.forwardModalVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.forwardModalVisible = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "Adresse Email"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.forwardTo),
      callback: function($$v) {
        _vm.forwardTo = $$v
      },
      expression: "forwardTo"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.forwardId = null
      }
    }
  }, [_vm._v("Fermer")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.forward()
      }
    }
  }, [_vm._v("Transférer")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76c22794"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents/Main/Customers/Emails.vue
// module id = 712
// module chunks = 1